// extracted by mini-css-extract-plugin
export default {"bodyModal":"ITDOQRJhVVZN0yhy_Ph_","modalHeader":"I4zxE8rKRKjtd34mV6nl","modalContent":"_YPbGtN1QTwHn6e2rb_A"};